export default {
  app_title:'QApi Document',
  api_url: "/",
};
